<template>
  <div id="app">

    <div class="p-3"><TicketForm /></div>
 
  </div>
</template>

<script>
/* eslint-disable */
import TicketForm from "@/components/TicketForm.vue";

export default {
  name: "App",
  components: {
    TicketForm,
  },
};
</script>

<style></style>
